import React, { useEffect } from "react";
import Image from "next/image";
import styles from "../../styles/shap_of_you.module.scss";
import shapofyoulogo from "../../assets/images/SENCO-SHAPE-OF-YOU-FULL_2.gif";
import sencoLogo from "../../assets/images/shap-main-senco.png";
import { MobileNavigationProps } from "./types";

interface SplashScreenProps extends MobileNavigationProps {
  autoNavigateDelay?: number;
}

const SplashScreen: React.FC<SplashScreenProps> = ({
  navigateToStep,
  autoNavigateDelay = 5000,
}) => {
  // Auto-navigate to walkthrough after delay
  useEffect(() => {
    const timer = setTimeout(() => {
      navigateToStep("walkthrough");
    }, autoNavigateDelay);

    return () => clearTimeout(timer);
  }, [navigateToStep, autoNavigateDelay]);

  return (
    <div className="d-md-none w-100">
      <div className={styles.mobile_view_shap}>
        <div className={styles.shapeOfYou}>
          <div className={styles.content}>
            <div className={styles.title}>
              <Image src={shapofyoulogo} alt="Shape of You Logo" />
            </div>
            <div className={styles.byLine}>
              <Image
                src={sencoLogo}
                alt="Senco Gold & Diamonds"
                className={styles.logo}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
